import { useTranslation as e } from "../../i18n/hooks.js";
import { Pagination as t } from "./primitive/pagination.js";
import { Fragment as n, jsx as r, jsxs as i } from "react/jsx-runtime";
//#region src/table/pagination/pagination-bar.tsx
function a({ hasNextPage: a, hasPreviousPage: o, limit: s, onNextPage: c, onPreviousPage: l, onLimitChange: u, rootProps: d, selectProps: f, prevButtonProps: p, nextButtonProps: m }) {
	let { t: h } = e();
	return /* @__PURE__ */ i(t.Root, {
		...d,
		children: [u && /* @__PURE__ */ r(n, { children: /* @__PURE__ */ r(t.Select, {
			label: h("public_pages_purchase.table.pagination.results_per_page"),
			value: s,
			onValueChange: (e) => {
				e != null && u(Number(e));
			},
			...f
		}) }), /* @__PURE__ */ i("div", {
			className: "flex items-center gap-1",
			children: [/* @__PURE__ */ r(t.Button, {
				direction: "prev",
				onClick: l,
				disabled: !o,
				...p
			}), /* @__PURE__ */ r(t.Button, {
				direction: "next",
				onClick: c,
				disabled: !a,
				...m
			})]
		})]
	});
}
//#endregion
export { a as PaginationBar };
